<template>
    <div>
        <div class="top">
            <van-nav-bar title="详情" left-text="返回" left-arrow @click-left="onClickLeft"/>
        </div>
        <!-- 新闻内容 -->
        <div class="newsBox">
            <p class="title">{{newsInfo.title}}</p>
            <div class="status">
                <div>{{newsInfo.create_time}}</div>
                <div class="iconGroup">
                    <div class="like" @click="collectNews(newsInfo)">
                        <van-icon name="like" color="#e5b626" v-if="celled==true"/>
                        <van-icon name="like-o" color="#ced8e1" v-if="celled==false"/>
                        <span>{{collection}}</span>
                    </div>
                    <div class="pinglun">
                        <van-icon name="comment-o" color="#ced8e1"/>
                        <span>{{newsInfo.comments}}</span>
                    </div>
                </div>
            </div>
            <div class="content" v-html="newsInfo.content">
            </div>
        </div>
        <!-- 评论 -->
        <div class="bgLine"></div>
        <div class="comment">
            <p class="comTop">用户留言</p>
            <ul class="commentLi">
                <li v-for="(item,index) in commentList" :key="index">
                   <div class="userImg">
                       <img :src="item.head_pic" alt>
                   </div>
                   <div class="commentRight">
                       <div>
                           <span class="userName">{{item.nickname}}：</span><span>{{item.content}}</span>
                       </div>
                       <p>{{item.addtime}}</p>
                   </div>
                </li>
            </ul>
        </div>
        <!-- 写留言 -->
        <div class="commentBottom">
            <div class="inputBottom" @click="goComment(newsInfo)">
                <van-icon name="edit" size="1.2rem"/>
                <p>写留言...</p>
            </div>
            <div class="infoBottom">
                <div class="status">
                    <div class="iconGroup">
                        <div class="like" @click="collectNews(newsInfo)">
                            <van-icon name="like" color="#e5b626" v-if="celled"/>
                            <van-icon name="like-o" color="#ced8e1" v-else/>
                            <span>{{collection}}</span>
                        </div>
                        <div class="pinglun">
                            <van-icon name="comment-o" color="#ced8e1"/>
                            <span>{{newsInfo.comments}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { httpPostRequest } from "../../axios/post";
export default {
    data(){
        return{
            newsId:this.$route.params.newsId,
            newsInfo:{},
            commentList:[],
            collection:'',   //收藏数
            celled:'',        //是否收藏
        }
    },
    methods:{
        // 返回上一页
        onClickLeft(){
            this.$router.go(-1);
        },
        // 去留言页
        goComment(newsInfo){
            this.$store.state.newsId = newsInfo.id;
            this.$router.push("/writeComment");
        },
        // 收藏文章
        collectNews(newsInfo){
            var article_id = newsInfo.id;
            httpPostRequest({
                route:2,
                type:"post",
                url:"/usercell/article_cell",
                data:{user_id: this.$store.state.userInfo.user_id,article_id:article_id}
            })
            .then( response =>{
                if(response.data == "收藏成功"){
                    this.collection = response.num;
                    this.celled = true;
                }
                if(response.data == "取消收藏成功"){
                    this.collection = response.num;
                    this.celled = false;
                }
            })
        },
        // 加载新闻详情
        loadnewsDetail() {
            httpPostRequest({
                route: 2,
                type: "post",
                url: "/news/details",
                data: {user_id: this.$store.state.userInfo.user_id,id:this.newsId}
            })
            .then(response => {
                if (response.code === 1) {
                    this.newsInfo = response.data;
                    this.collection = response.data.collection;
                    if(response.data.celled==true){
                        this.celled=true;
                    }else{
                        this.celled=false;
                    }
                }
            });
        },
        // 加载用户留言
        loadcommentList(){
            httpPostRequest({
                route:2,
                type:"post",
                url:"/news/comment_list",
                data:{user_id: this.$store.state.userInfo.user_id,id:this.$store.state.newsId}
            })
            .then(response =>{
                if(response.code === 1){
                    this.commentList = response.list;
                }
            })
        }
    },
    mounted(){
        this.loadnewsDetail();
        this.loadcommentList();
    }
}
</script>

<style scoped>
.content>>>img{
    width: 100%!important;
}
.top{
    background: #22d9d9;
    color: #fff;
    font-size: 1rem;
    text-align: center;
}
.newsBox{
    width: 96vw;
    margin: 0 auto;
    padding: 1rem 0;
}
.title{
    font-size: 1.6rem;
    color: #444;
    padding: 0.4rem 0.6rem;
    line-height: 2.8rem;
    margin-bottom: 1rem;
}
/* 收藏评论 */
.newsBox .status{
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  color: #878787;
  padding:0 0.6rem;
}
.newsBox .iconGroup{
  display: flex;
  align-items: center;
  font-size: 1rem;
}
.newsBox .van-icon{
  margin-right: 0.6rem;
}
.newsBox .like,.pinglun{
  margin-right: 1rem;
  display: flex;
  align-items: center;
}
.content{
    margin: 1rem 0;
    font-size: 1rem;
    color: #878787;
    line-height: 1.8rem;
    padding: 0.5rem;
}
.content p{
    margin-bottom: 0.8rem;
    width: 100%;
}
img{
    width: 100%;
}
.bgLine{
    height: 10px;
    background-color: #f5f9fa;
}
/* 留言 */
.comment{
    width: 92vw;
    margin: 0 auto;
}
.comTop{
    padding: 1rem 0;
    font-size: 1.2rem;
    color: #282828;
    margin-bottom: 1rem;
}
.commentLi li{
    display: flex;
    margin-bottom: 1rem;
}
.userImg{
    width: 2.6rem;
    height: 2.6rem;
    border-radius: 1.3rem;
    margin-right: 1rem;
    overflow: hidden;
}
.userImg img{
    width: 100%;
    height: 100%;
}
.commentRight{
    width:80%;
    color: #878787;
}
.commentRight div{
    line-height: 1.3rem;
}
.userName{
    color: #282828;
    margin-right: 0.4rem;
    font-size: 1rem;
}
/* 写留言 */
.commentBottom{
    background: #fafafa;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    padding: 1rem;
}
.inputBottom{
    width: 50%;
    background: #fff;
    height: 2rem;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
.inputBottom .van-icon{
    margin-right: 0.5rem;
}
.inputBottom p{
    font-size: 0.8rem;
}
.infoBottom .iconGroup{
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: #878787;
}
.infoBottom .van-icon{
  margin-right: 0.6rem;
}
.infoBottom .like,.pinglun{
  margin-right: 1rem;
  display: flex;
  align-items: center;
}
</style>

